import { JobPhaseGarageInterface } from '../interfaces/job-phase-garage.interface';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import {
  IsNumber,
  IsOptional,
  IsUUID,
  Min,
  ValidateNested,
} from 'class-validator';
import { Exclude, Expose, Type } from 'class-transformer';
import { JobPhaseDto } from '../../job-phase/dto/job-phase.dto';
import { ContractorDto } from '../../contractor/dto/contractor.dto';
import { BoardPurchaseFloorDto } from '../../board-purchase-floor/dto/board-purchase-floor.dto';
import { BoardTypeInterface } from 'src/modules/board-type/interfaces/board-type.interface';
import { BoardTypeDto } from '../../board-type/dtos/board-type.dto';
import { GeographyPointDto } from '../../common/dto/geography-point.dto';
import { Point } from 'geojson';

@Exclude()
export class JobPhaseGarageDto implements JobPhaseGarageInterface {
  @ApiProperty({
    title: 'Quantity Number',
    description: 'Quantity Number',
  })
  @IsNumber()
  @Expose()
  quantityAvaliable!: number;

  @ApiProperty({
    title: 'Completion Date',
  })
  @Expose()
  completionDate!: Date;

  @ApiProperty({
    title: 'Quantity Number',
    description: 'Quantity Number',
  })
  @IsNumber()
  @Expose()
  quantity!: number;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated Job Phase ID',
  })
  @IsUUID()
  @Expose()
  jobPhaseId!: string;

  @ApiPropertyOptional({
    type: () => JobPhaseDto,
    title: 'Job Phase',
    description: 'The Job Phase associated with this Job Phase Bumper ',
  })
  @Expose()
  jobPhase?: JobPhaseDto;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated Purchase Contractor ID',
  })
  @IsUUID()
  @Expose()
  contractorId!: string;

  @ApiPropertyOptional({
    type: () => ContractorDto,
    title: 'Contractor ',
    description: 'Contractor ',
  })
  @Expose()
  contractor?: ContractorDto;

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Associated Purchase Floor IDD',
  })
  @IsUUID()
  @Expose()
  boardTypeId!: string;

  @ApiPropertyOptional({
    type: () => BoardTypeDto,
    title: 'BoardTypeDto ',
    description: 'BoardTypeDto ',
  })
  @Expose()
  boardType?: BoardTypeDto;

  @ApiPropertyOptional({
    type: () => GeographyPointDto,
    nullable: true,
    default: null,
    title: 'Approved Geo',
    description: 'GPS location of device when the garage phase was approved.',
  })
  @IsOptional()
  @ValidateNested()
  @Type(() => GeographyPointDto)
  @Expose()
  approvedGeo?: Point | null;

  @ApiPropertyOptional({
    title: 'Approved Geo Accuracy',
    description:
      'Accuracy in meters of the GPS reading when the garage phase was approved.',
    nullable: true,
  })
  @IsOptional()
  @IsNumber()
  @Min(0)
  @Expose()
  approvedGeoAccuracy?: number | null;
}
